var _path, _path2, _rect, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 305,
    viewBox: "0 0 373 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0645 211.674L97.8809 56.1562H118.447L123.145 82.0547L83.916 241H61.8262L61.0645 211.674ZM42.1484 56.1562L72.6172 211.674L70.0781 241H45.4492L4.44336 56.1562H42.1484ZM155.518 211.039L185.605 56.1562H223.311L182.432 241H157.803L155.518 211.039ZM130 56.1562L167.07 212.309L166.055 241H143.965L104.482 81.9277L109.561 56.1562H130Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.83 46.3838L268.693 123H248.444L282.785 30.5781H295.671L293.83 46.3838ZM314.714 123L289.514 46.3838L287.482 30.5781H300.495L335.026 123H314.714ZM313.571 88.5957V103.513H264.758V88.5957H313.571Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 140,
    width: 63,
    height: 26,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239 150C239 144.477 243.477 140 249 140H253V166H249C243.477 166 239 161.523 239 156V150Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M345 153L326.25 165.99V140.01L345 153Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhite);
export default __webpack_public_path__ + "static/media/icon_white.9962b4fca00c88274b29357053e29827.svg";
export { ForwardRef as ReactComponent };